import React, { Component } from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import "./scss/style.scss";
import { useSelector, useDispatch, connect } from "react-redux";
import { handlelogin, handleloginnull } from "./actions/loginAction";
import jwtDecode from "jwt-decode";
import JobListing from "./pages/humanresource/JobListing";
import PartnerProfile from "./pages/AccountSetting/partnerProfile";
import "leaflet/dist/leaflet.css";
import {
  FaComments,
  FaTimes,
  FaPaperPlane,
  FaExpand,
  FaCompress,
} from "react-icons/fa";
const LoginOTP = React.lazy(() => import("./pages/login/LoginOTP"));

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);
const HomeSignin = React.lazy(() => import("./pages/Landing/HomeSignin"));
const HomeSignup = React.lazy(() => import("./pages/Landing/HomeSignup"));
const HomeProduct = React.lazy(() => import("./pages/Landing/HomeProduct"));
const Home = React.lazy(() => import("./pages/Landing/Home"));
// Containers
const TheLayout = React.lazy(() => import("./containers/TheLayout"));
const TheProductionLayout = React.lazy(
  () => import("./containers/TheProductionLayout"),
);

// Pages
const Login = React.lazy(() => import("./pages/login/Login"));
const SignupPage = React.lazy(() => import("./pages/login/SignupPage"));
const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));
const CheckoutPage = React.lazy(() => import("./pages/login/CheckoutPage"));
const ForgotPassword = React.lazy(() => import("./pages/login/ForgotPassword"));
const VerifyUser = React.lazy(() => import("./pages/login/VerifyUser"));
const myprofile = React.lazy(() => import("./pages/humanresource/Profile"));
const SalesOrderCallback = React.lazy(
  () => import("./pages/setup/SalesOrderCallback"),
);
const PaymentStatusPage = React.lazy(
  () => import("./pages/setup/PaymentStatusPage"),
);
const accountdemo = React.lazy(() => import("../src/accounting/accountdemo"));

class App extends Component {
  state = {
    showChatModal: false,
    chatMinimized: false,
    chatFullScreen: false,
    enquiryForm: {
      name: "",
      email: "",
      phone: "",
      message: "",
    },
    enquirySent: false,
  };

  openChatModal = () => {
    this.setState({
      showChatModal: true,
      chatMinimized: false,
      chatFullScreen: false,
    });
  };

  toggleChatMinimize = () => {
    this.setState((prevState) => ({ chatMinimized: !prevState.chatMinimized }));
  };

  toggleChatFullScreen = () => {
    this.setState((prevState) => ({
      chatFullScreen: !prevState.chatFullScreen,
    }));
  };

  closeChatModal = () => {
    this.setState({
      showChatModal: false,
      chatMinimized: false,
      chatFullScreen: false,
    });
  };

  handleEnquiryChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      enquiryForm: {
        ...prevState.enquiryForm,
        [name]: value,
      },
    }));
  };

  sendEnquiry = () => {
    const { enquiryForm } = this.state;
    if (
      !enquiryForm.name.trim() ||
      !enquiryForm.email.trim() ||
      !enquiryForm.message.trim()
    ) {
      return;
    }
    this.setState({ enquirySent: true });
    setTimeout(() => {
      this.setState({
        enquirySent: false,
        enquiryForm: { name: "", email: "", phone: "", message: "" },
        showChatModal: false,
        chatMinimized: false,
        chatFullScreen: false,
      });
    }, 1400);
  };

  render() {
    localStorage.setItem("Dashboard", "Dashboard");
    localStorage.setItem("Appointment", "Appointment");
    localStorage.setItem("Billing", "Billing");
    localStorage.setItem("OPD - Out Patient", "OPD - Out Patient");
    localStorage.setItem("IPD - In Patient", "IPD - In Patient");
    localStorage.setItem("Pharmacy", "Pharmacy");
    localStorage.setItem("Pathology", "Pathology");
    localStorage.setItem("Radiology", "Radiology");
    localStorage.setItem("Dental Lab Entry", "Dental Lab Entry");
    localStorage.setItem("Blood Bank", "Blood Bank");
    localStorage.setItem("Ambulance", "Ambulance");
    localStorage.setItem("Front Office", "Front Office");
    localStorage.setItem("Birth & Death Record", "Birth & Death Record");
    const checkAuth = () => {
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") === "false"
      ) {
        return false;
      } else if (
        jwtDecode(localStorage.getItem("token")).exp <
        Date.now() / 1000
      ) {
        localStorage.setItem("token", false);
        return false;
      }
      if (localStorage.getItem("is_otp_verified") !== "true") {
        return false;
      }
      return true;
    };

    const PrivateRoute = ({ component: Component, ...rest }) => (
      <Route
        {...rest}
        render={(props) =>
          checkAuth() ? <Component {...props} /> : <Redirect to="/homesignin" />
        }
      />
    );
    return (
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              exact
              path="/salesorder/callback"
              name="Sales Order Callback"
              component={SalesOrderCallback}
            />
            <Route
              exact
              path="/payment-status"
              name="Payment Status"
              component={PaymentStatusPage}
            />
            <Route
              exact
              path="/"
              render={() =>
                checkAuth() ? <Redirect to="/dashboard" /> : <HomeSignin />
              }
            />
            <Route
              exact
              path="/standalone/job-listing/:hid"
              name="Job Listing Widget"
              render={(props) => (
                <div
                  style={{
                    padding: "20px",
                    background: "#f8f9fa",
                    minHeight: "100vh",
                  }}
                >
                  <JobListing {...props} />
                </div>
              )}
            />
            <Route
              exact
              path="/standalone/partner-products/:hid"
              name="Partner Product Widget"
              render={(props) => (
                <div
                  style={{
                    padding: "20px",
                    background: "#f8f9fa",
                    minHeight: "100vh",
                  }}
                >
                  <PartnerProfile {...props} />
                </div>
              )}
            />
             <Route
              exact
              path="/home"
              name="Home Page"
              component={Home}
            />
            <Route
              exact
              path="/homesignin"
              name="Login Page"
              component={HomeSignin}
            />
            <Route
              exact
              path="/homesignup"
              name="Signup Page"
              component={HomeSignup}
            />
            <Route
              exact
              path="/homeproduct"
              name="Product Page"
              component={HomeProduct}
            />
            <Route exact path="/login" name="Login Page" component={Login} />
            <Route
              exact
              path="/signup"
              name="Signup Page"
              component={SignupPage}
            />
            <Route
              exact
              path="/login/ForgotPassword"
              name="ForgotPassword"
              component={ForgotPassword}
            />
            <Route
              exact
              path="/login/VerifyUser/:token"
              name="Verify User"
              component={VerifyUser}
            />
            <Route
              exact
              path="/login/CheckoutPage"
              name="CheckoutPage"
              component={CheckoutPage}
            />
            <Route
              exact
              path="/verify-login-otp"
              name="Login OTP"
              component={LoginOTP}
            />
            <Route exact path="/404" name="Page 404" component={Page404} />
            <Route exact path="/500" name="Page 500" component={Page500} />
            {/* <Route path="/humanresource/profile" name="My Profile" component={myprofile} /> */}
            <Route
              exact
              path="/accountdemo"
              name="Account Demo"
              component={accountdemo}
            />
            {/* <PrivateRoute component={TheProductionLayout} /> */}
             <PrivateRoute component={TheLayout} />
          </Switch>
         
        </React.Suspense>
      </HashRouter>
    );
  }
}

const mapStateToProps = (state) => ({
  loginData: state.loginReducer.loginData,
});
export default connect(mapStateToProps, {
  handlelogin,
  handleloginnull,
})(App);
